import './event.css'
import news from '../../img/news.jpg'
import contact from '../../img/contact.jpg'
import seminar from '../../img/seminar.jpg'
import course from '../../img/course.jpg'
import { Link } from 'react-router-dom'
import { useInView } from 'react-intersection-observer'
import { motion } from 'framer-motion'
export default function Event(props) {
    const { ref , inView } = useInView({threshold: 0.1 , triggerOnce: true})
    return (
        <motion.div className='eventbox' ref={ref} initial={{ opacity: 0, x: 50 }} animate={ inView ? { opacity: 1, x:0 } : {}} transition={{duration: 0.6}}>
            <ul>
            <Link to="/course" onClick={() => props.setSelectnav('/course')}><li>
                    <img src={course} alt='news' loading='lazy'></img>
                    <h3>دوره</h3>
                </li></Link>
                <Link to="/seminar" onClick={() => props.setSelectnav('/seminar')}><li>
                    <img src={seminar} alt='seminar' loading='lazy'></img>
                    <h3>سمینار</h3>
                </li></Link>
                <Link to="/news" onClick={() => props.setSelectnav('/news')}><li>
                    <img src={news} alt='news' loading='lazy'></img>
                    <h3>اخبار</h3>
                </li></Link>
                <Link to="/contact" onClick={() => props.setSelectnav('/contact')}><li>
                    <img src={contact} alt='contact' loading='lazy'></img>
                    <h3>تماس</h3>
                </li></Link>
            </ul>
        </motion.div>
    )
}